import mime from 'mime/lite';
import { useMemo } from 'react';

export function useAccept(accept: string[]) {
  const [format, mimes] = useMemo(() => {
    return [
      accept.join(','),
      accept
        .map((item) => {
          if (item.includes('/')) {
            return item;
          }

          return mime.getType(item);
        })
        .filter((item) => item != null),
    ];
  }, [accept]);

  return useMemo(
    () => ({
      format,
      filter: (file: File) => {
        return mimes.some((item) => {
          const [type, subtype] = item.split('/');
          const [fileType, fileSubtype] = file.type.split('/');

          if (type !== fileType) {
            return false;
          }

          if (subtype === '*') {
            return true;
          }

          return subtype === fileSubtype;
        });
      },
    }),
    [format, mimes],
  );
}
